import { ReceptionComment } from "../reception";

// 依頼詳細コメントセットmodel
export class ReceptionCommentSet {
  public receptionDetailId: number;
  public isReadOnly: boolean;
  public comments: ReceptionComment[] = [];
  public restrictComments: ReceptionComment[] = [];
  public nextMessages: ReceptionComment[] = [];
  public backMessages: ReceptionComment[] = [];
  public contactedComments: ReceptionComment[] = [];
  public delComments: ReceptionComment[] = [];
  public conflictComments: ReceptionComment[] = [];

  clone(): ReceptionCommentSet {
    const newObj = new ReceptionCommentSet();

    newObj.receptionDetailId = this.receptionDetailId;
    newObj.isReadOnly = this.isReadOnly;
    newObj.comments = this.comments;
    newObj.restrictComments = this.restrictComments;
    newObj.nextMessages = this.nextMessages;
    newObj.backMessages = this.backMessages;
    newObj.contactedComments = this.contactedComments;
    newObj.delComments = this.delComments;
    newObj.conflictComments = this.conflictComments;

    return newObj;
  }
}
